<template>
  <svg
    viewBox="0 0 5 3"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      width="5"
      height="1"
      fill="#ED2939"
    />
    <rect
      y="1"
      width="5"
      height="1"
      fill="#fff"
    />
    <rect
      y="2"
      width="5"
      height="1"
      fill="#ED2939"
    />
  </svg>
</template>

<script>
export default { name: 'FlagAt' };
</script>
